// @generated source--
// scripts/generate-fl-icons.ts

/**
 * fl-ng-icon names whose kebab SVG asset can't be reconstructed by
 * `reverseByRule` (`ui-` stripped, or a digit segment), mapping the const
 * name → its kebab name. Used by `constNameToIconName`.
 *
 * Run: yarn prepare:fl-icons to regenerate
 * DO NOT EDIT MANUALLY
 */
export const FL_ICON_REVERSE_EXCEPTIONS: Record<string, string> = {
  flAiDiamond: 'ai-diamond',
  coolHouse01: 'cool-house-01',
  coolUser02: 'cool-user-02',
  flFliconCommunity: 'flicon-community',
  flStar4pt: 'ui-star-4pt',
};
